<!-- StepDropZone.vue -->
<script setup>
import { ref } from 'vue';

const props = defineProps({
  procedureIndex: {
    type: Number,
    required: true,
  },
  stepIndex: {
    type: Number,
    required: true,
  },
  acceptsDrop: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toolDropped']);

const isDragOver = ref(false);
const dragCounter = ref(0);

const handleDragEnter = event => {
  event.preventDefault();
  dragCounter.value += 1;
  isDragOver.value = props.acceptsDrop;
};

const handleDragLeave = event => {
  event.preventDefault();
  dragCounter.value -= 1;
  if (dragCounter.value === 0) {
    isDragOver.value = false;
  }
};

const handleDragOver = event => {
  event.preventDefault();
  event.dataTransfer.dropEffect = props.acceptsDrop ? 'copy' : 'none';
};

const handleDrop = event => {
  event.preventDefault();
  isDragOver.value = false;
  dragCounter.value = 0;
  if (!props.acceptsDrop) return;

  try {
    const data = JSON.parse(event.dataTransfer.getData('application/json'));
    if (data.type === 'item') {
      emit('toolDropped', {
        tool: data.item,
        procedureIndex: props.procedureIndex,
        stepIndex: props.stepIndex,
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error parsing dropped data:', error);
  }
};
</script>

<template>
  <div
    class="step-drop-zone relative"
    :class="{
      'drag-over': isDragOver,
    }"
    @dragenter="handleDragEnter"
    @dragleave="handleDragLeave"
    @dragover="handleDragOver"
    @drop="handleDrop"
  >
    <slot />

    <!-- Drop Overlay -->
    <transition name="drop-overlay">
      <div
        v-if="isDragOver"
        class="absolute inset-0 border-2 border-dashed border-purple-500 dark:border-purple-800 rounded-lg flex items-center justify-center z-10 pointer-events-none"
      >
        <div
          class="flex flex-col justify-center items-center text-center bg-white/50 dark:bg-slate-900/60 h-full w-full rounded-lg"
        >
          <!-- <div class="text-2xl mb-2 text-purple-800 dark:text-purple-900">
            <i class="i-lucide-wrench" />
          </div> -->
          <p class="text-sm font-medium text-purple-800 dark:text-purple-900">
            {{ $t('ASSISTANT_MGMT.PROCEDURES.DROP_ITEM_HERE') }}
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.step-drop-zone {
  min-height: 100px;
}

.step-drop-zone.drag-over {
  position: relative;
}

.drop-overlay-enter-active,
.drop-overlay-leave-active {
  transition: opacity 0.2s ease;
}

.drop-overlay-enter-from,
.drop-overlay-leave-to {
  opacity: 0;
}
</style>
